import { LocalVideoTrack } from "twilio-video";
import { LocalVideoDelegator } from "../../../../core/room/participant/media/MediaDelegator";

export class TwilioLocalVideoDelegator implements LocalVideoDelegator {
  readonly kind = "video" as const;
  #track: LocalVideoTrack;

  constructor(videoTrack: LocalVideoTrack) {
    this.#track = videoTrack;
  }

  get deviceId() {
    return this.#track.mediaStreamTrack.getSettings().deviceId;
  }

  get isEnabled() {
    return !!this.#track.isEnabled;
  }

  async attach(element?: HTMLVideoElement) {
    await this.#track.attach(element);
  }

  async detach(element?: HTMLVideoElement) {
    if (element) {
      await this.#track.detach(element);
    }
  }

  // Not part of the interface, used for backwards compatibility
  get track() {
    return this.#track;
  }
}
